import React, { useState, lazy, Suspense } from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

const OfferRequestForm = lazy(() => import('@/components/OfferRequestForm'));

const content = {
  heading: 'Tu alegi cum treci la energie solară.',
  subtitle: 'Plată integrală sau în rate — decizia e a ta. Prețul final depinde de dimensiunea sistemului, acoperiș și consum.',
  cta: 'Solicită ofertă detaliată',
};

const PricingSection: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-[1fr_2fr] gap-10 lg:gap-16 items-start">
          {/* Left side */}
          <div className="text-background">
            <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold leading-[1.1] tracking-tight mb-5 max-w-md">
              {content.heading}
            </h2>
            <p className="text-background/60 text-base md:text-lg leading-relaxed mb-8 max-w-sm">
              {content.subtitle}
            </p>
            <Button
              size="lg"
              onClick={() => setIsFormOpen(true)}
              className="bg-accent hover:bg-accent/90 text-accent-foreground px-8"
            >
              {content.cta}
            </Button>
          </div>

          {/* Pricing cards */}
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="bg-background rounded-2xl p-6 md:p-8">
              <p className="text-accent font-semibold text-sm mb-2">Achiziție directă</p>
              <h3 className="text-2xl md:text-3xl font-bold mb-2">De la 15.000 lei</h3>
              <p className="text-muted-foreground text-sm mb-6">
                TVA inclus. Investești o dată, economisești zeci de ani.
              </p>
              <ul className="space-y-3">
                {[
                  'Sistem complet instalat, la cheie',
                  'Garanție extinsă pe echipamente',
                  'Amortizare în 4-7 ani',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <Check size={18} className="text-accent flex-shrink-0 mt-0.5" />
                    <span className="text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-muted-foreground text-xs mt-6">
                * Preț orientativ pentru un sistem de 3 kWp. Variază în funcție de acoperiș, consum și zonă.
              </p>
            </div>

            <div className="bg-background rounded-2xl p-6 md:p-8">
              <p className="text-accent font-semibold text-sm mb-2">Rate lunare</p>
              <h3 className="text-2xl md:text-3xl font-bold mb-2">De la 349 lei/lună</h3>
              <p className="text-muted-foreground text-sm mb-6">
                Fără avans. Accesibil pentru orice familie.
              </p>
              <ul className="space-y-3">
                {[
                  'Fără avans sau contribuție proprie',
                  'Rată lunară accesibilă',
                  'Economii din prima zi',
                  'Garanție completă inclusă',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <Check size={18} className="text-accent flex-shrink-0 mt-0.5" />
                    <span className="text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-muted-foreground text-xs mt-6">
                * Preț orientativ pentru un sistem de 3 kWp. Variază în funcție de acoperiș, consum și zonă.
              </p>
            </div>
          </div>
        </div>
      </div>

      {isFormOpen && (
        <Suspense fallback={null}>
          <OfferRequestForm open={isFormOpen} onOpenChange={setIsFormOpen} />
        </Suspense>
      )}
    </section>
  );
};

export default PricingSection;
